import { render, staticRenderFns } from "./MatriculasPorUnidade.vue?vue&type=template&id=69931af2&scoped=true&"
import script from "./MatriculasPorUnidade.vue?vue&type=script&lang=js&"
export * from "./MatriculasPorUnidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69931af2",
  null
  
)

export default component.exports